import { render, staticRenderFns } from "./CustomServiceLayout.vue?vue&type=template&id=bfd0180a&scoped=true"
import script from "./CustomServiceLayout.vue?vue&type=script&lang=js"
export * from "./CustomServiceLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomServiceLayout.vue?vue&type=style&index=0&id=bfd0180a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd0180a",
  null
  
)

export default component.exports